export const FETCH_REWARD_POINTS = {
  LOADING: 'fetchRewardPointsLoading',
  SUCCESS: 'fetchRewardPointsSuccess',
  FAIL: 'fetchRewardPointsFail'
};
